<script>
  /**
 *
 *
 *
 */

  /*                */
  let { benefitDiscountValuePercent, benefitId = null } = $props();

  /*                                                                                                           */
  const benefitBadgeUrl = `/benefit-sheet/sheet/reco/${benefitId}`;
</script>

<div class="reco_comparison__customer-benefit-badge reco_comparison__label-visibility oc-mt-25">
  <oc-tag-v1
    size="50"
    variant="sale"
    show-info-icon
    class="js_openInPaliSheet"
    data-sheet-url={benefitBadgeUrl}
    data-sheet-lock-mobile-height="false">
    {benefitDiscountValuePercent}
  </oc-tag-v1>
</div>

<style>
  .reco_comparison__label-visibility {
    z-index: 1;
  }
</style>
